<div class="homeworkLoading alert alert-warning spacer-lg wide" khA11yAlert="status">
  <span>{{ 'HOMEWORK_LOADER.LOADING' | translate }}</span>
  <kh-img path="loading-blue-bar-anim.gif" khA11yHidden></kh-img>
</div>
